module.exports = __webpack_public_path__ + "static/media/delete.49eb646d.svg";